var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("I am available for")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-info",
            attrs: { "active-class": "" },
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-left" }),
            _vm._v(" Back\n      "),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-10 col-lg-8" },
            [
              _c("div", { staticClass: "panel panel-grey" }, [
                _c("div", { staticClass: "panel-body" }, [
                  _c("h4", { staticClass: "heading" }, [_vm._v("Packages")]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "package-list" },
                    _vm._l(_vm.packages, function (pkg, index) {
                      return _c("profile-talent-packages-list-item", {
                        key: pkg.id,
                        attrs: {
                          pkg: pkg,
                          validation: _vm.$v.packages.$each[index],
                          user: _vm.user,
                        },
                      })
                    }),
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "margin-20" }),
              _vm._v(" "),
              _c(
                "ladda-button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    type: "submit",
                    click: _vm.handleSavePackagesCallback,
                    disabled: _vm.$v.$invalid,
                  },
                },
                [_vm._v("\n            Save Changes\n          ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }